// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__sfhAr","mobileMenu":"Layout_mobileMenu__VVs23","main":"Layout_main__e1j6X","footer":"Layout_footer__g-dvr"};